import { DateTime } from 'luxon'
import type { ReactElement } from 'react'

export default function Time({
  time,
  format = 'hh:mm a dd LLL yyyy',
}: {
  time: string | null
  format?: string
}): ReactElement | null {
  if (time == null) {
    return null
  }

  const parsed = DateTime.fromISO(time)

  return (
    <time dateTime={parsed.toISO()} title={parsed.toFormat('fff')}>
      {parsed.toFormat(format)}
    </time>
  )
}
